/**
 * @generated SignedSource<<94e0238d20f392e2121ad84d343cccaa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraGoalStatus = "ARCHIVED" | "AT_RISK" | "CANCELLED" | "COMPLETED" | "DONE" | "OFF_TRACK" | "ON_TRACK" | "PAUSED" | "PENDING" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type goalGroupHeader_nativeIssueTable$data = {
  readonly displayName: string;
  readonly goal: {
    readonly score: number | null | undefined;
    readonly status: JiraGoalStatus | null | undefined;
  };
  readonly " $fragmentType": "goalGroupHeader_nativeIssueTable";
};
export type goalGroupHeader_nativeIssueTable$key = {
  readonly " $data"?: goalGroupHeader_nativeIssueTable$data;
  readonly " $fragmentSpreads": FragmentRefs<"goalGroupHeader_nativeIssueTable">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "goalGroupHeader_nativeIssueTable",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "displayName"
    },
    {
      "concreteType": "JiraGoal",
      "kind": "LinkedField",
      "name": "goal",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "status"
        },
        {
          "kind": "ScalarField",
          "name": "score"
        }
      ]
    }
  ],
  "type": "JiraJqlGoalsFieldValue"
};

(node as any).hash = "7fbbb80a8521fb1b5280c44ed08dc995";

export default node;
